import { AppBar as MAppBar, AppBarProps } from '@mui/material'

export const AppBar: React.FC<AppBarProps> = (props) => {
  return <MAppBar {...props} />
}
